import React, { FC, KeyboardEvent, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { getQueryParam } from '../../helpers/url/urlHelpers';
import { ReactComponent as ArrowRight } from '../../icons/arrow-right-2.svg';
import ISettingsViewModel from '../../interfaces/umbracoNodes/settingsViewModel';
import IconButton from '../iconButton';
import { Input, InputRoot, SubmitButtonWrapper } from './trackShipment.styles';

interface Props {
	placeholder: string;
}

const TrackShipmentInput: FC<Props> = ({ placeholder }) => {
	const { settings }: { settings: ISettingsViewModel } = useSelector(
		(state: { pageReducer: { settings: ISettingsViewModel } }) => state.pageReducer
	);
	const [trackingNumber, setTrackingNumber] = useState(
		getQueryParam('q') || getQueryParam('TrackingNumber') || getQueryParam('trackingNumber') || ''
	);

	const anchorRef = useRef<HTMLAnchorElement>(null);

	const onInputChange = (event: KeyboardEvent) => {
		setTrackingNumber((event.target as HTMLInputElement).value.trim());
	};

	const onInputKeydown = (event: KeyboardEvent) => {
		if (event.keyCode === 13) {
			event.preventDefault();
			anchorRef.current.click();
		}
	};

	return (
		<InputRoot>
			<Input
				type="text"
				id="trackingNumber"
				name="trackingNumber"
				placeholder={placeholder}
				value={trackingNumber}
				onKeyDown={onInputKeydown}
				onChange={onInputChange}
			/>
			<SubmitButtonWrapper>
				<IconButton
					buttonRef={anchorRef}
					href={`${settings.Values.FindShipmentLink.Url}${trackingNumber ? `?q=${trackingNumber}` : ''}`}>
					<ArrowRight />
				</IconButton>
			</SubmitButtonWrapper>
		</InputRoot>
	);
};

export default TrackShipmentInput;
